(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideeasey-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('slideeasey-home'))customElements.define('slideeasey-home',class extends HTMLElement{
connectedCallback(){this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.abort=new AbortController();const opts={signal:this.abort.signal};this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),opts);this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.label()},opts);this.addEventListener('mouseenter',()=>this.hover=true,opts);this.addEventListener('mouseleave',()=>this.hover=false,opts);this.addEventListener('focusin',()=>this.focused=true,opts);this.addEventListener('focusout',e=>this.focused=this.contains(e.relatedTarget),opts);this.timer=setInterval(()=>{if(!this.paused&&!this.hover&&!this.focused&&!document.hidden)this.show(this.index+1)},6500);this.label();document.addEventListener('shopify:block:select',e=>{const s=e.target.closest('[data-slide]');if(s&&this.contains(s)){this.show(this.slides.indexOf(s));this.paused=true;this.label()}},opts)}
show(i){if(!this.slides.length)return;this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,j)=>s.hidden=j!==this.index);this.querySelector('[data-count]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0')}
label(){const b=this.querySelector('[data-pause]');b.textContent=this.paused?'▷':'Ⅱ';b.setAttribute('aria-label',this.paused?b.dataset.play:b.dataset.pauseLabel)}
disconnectedCallback(){clearInterval(this.timer);this.abort.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
